let googleMapsPromise = null

const GOOGLE_MAPS_SCRIPT_SELECTOR = 'script[src^="https://maps.googleapis.com/maps/api/js"]'
const FALLBACK_GOOGLE_MAPS_KEY = 'AIzaSyDu8fNQeQGyby_XgC0JZLOPtqFN7SFkmuY'

export const loadGoogleMaps = () => {
  if (window.google?.maps) return Promise.resolve(window.google.maps)
  if (googleMapsPromise) return googleMapsPromise

  googleMapsPromise = new Promise((resolve, reject) => {
    const finish = () => window.google?.maps ? resolve(window.google.maps) : reject(new Error('Google Maps SDK se nenačetlo.'))
    const existingScript = document.querySelector(GOOGLE_MAPS_SCRIPT_SELECTOR)

    if (existingScript) {
      existingScript.addEventListener('load', finish, { once: true })
      existingScript.addEventListener('error', () => reject(new Error('Google Maps SDK se nepodařilo načíst.')), { once: true })
      return
    }

    const script = document.createElement('script')
    const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || FALLBACK_GOOGLE_MAPS_KEY
    script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}`
    script.async = true
    script.defer = true
    script.addEventListener('load', finish, { once: true })
    script.addEventListener('error', () => reject(new Error('Google Maps SDK se nepodařilo načíst.')), { once: true })
    document.head.appendChild(script)
  }).catch((error) => {
    googleMapsPromise = null
    throw error
  })

  return googleMapsPromise
}
